document.addEventListener('DOMContentLoaded', function() {

    let $initViewer = false;
    let initViewerAttempts = 0;
    let maxInitViewerAttempts = 8;

    var element = document.getElementById("googleViewerIframe");

    if (element !== null && $initViewer == false) {

        document.getElementById("googleViewerIframe").onload = function() {
            console.log("Google Viewer ініціалізований на сторінці.");
            $initViewer = true;
            clearInterval(intervalId);
            textLabel = document.getElementById("loadDocumentMenu");

            if (textLabel !== null) {
                textLabel.style.display = "none";
            }
        }

        intervalId = setInterval(updateGoogleViewerInterval, 2000);
    }

    window.updateGoogleViewer = function updateGoogleViewer() {
        var iframe = document.getElementById("googleViewerIframe");
        var dataUrl = iframe.getAttribute("data-url");
        if (dataUrl !== null) {
            var viewerUrl = "https://docs.google.com/gview?url=" + dataUrl + "&embedded=true";
            iframe.src = viewerUrl;
        } else {
            $initViewer = true;
        }
    }

    function updateGoogleViewerInterval() {
        initViewerAttempts ++;
        console.log('Init google viewer. Attempts ' + initViewerAttempts);

        if ($initViewer == false && initViewerAttempts < maxInitViewerAttempts) {
            updateGoogleViewer();
        } else {
            clearInterval(intervalId);
            $initViewer = true;
        }
    }
});
